
import EventPublisher from "../utils/EventPublisher";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


export default class PhoneNumberVerificationAPIClient {
    constructor() {
        this.requestSMSResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("SMS_SENT", this.onSMSSent));

        this.checkCodeResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("INVALID_SMS_VALIDATION_CODE", this.onInvalidSMSCode)
                    .set("SMS_VALIDATION_SUCCESS", this.onSMSValidated));
    }

    checkCode(validationCode) {
        SecureRequestExecuter.executePUTRequest(
            "/api/private/phone_number_validation",
            {},
            {
                "sms_verification_code": validationCode
            },
            {},
            this.checkCodeResponseHandler);
    }

    requestSMS() {
        SecureRequestExecuter.executePOSTRequest(
            "/api/private/phone_number_validation",
            {},
            {},
            {},
            this.requestSMSResponseHandler);
    }

    onSMSSent = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(
            ActionResultEvents.PHONE_NUMBER_VERIFICATION_SMS_SENT,{});
    };

    onSMSValidated = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.PHONE_NUMBER_VERIFICATION_SUCCESS, {});
    };

    onInvalidSMSCode = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.PHONE_NUMBER_VERIFICATION_INVALID_CODE, {});
    };

}